.row {
  display: grid;
  gap: 16px;
}

.labelCell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: var(--color-gray-50);
}

.labelText {
  font-weight: 700;
}

.fieldCell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding: 0 8px;
  font-size: var(--font-size-sm);
  word-break: break-all;
}

@media screen and (width >= 769px) {
  .row {
    grid-template-columns: 225px 1fr;
    gap: 0;
    border: 1px solid var(--color-border-normal);
    border-bottom: none;

    &:last-of-type {
      border-bottom: 1px solid var(--color-border-normal);
    }
  }

  .labelCell {
    padding: 20px 16px;
    border-right: 1px solid var(--color-border-normal);
  }

  .fieldCell {
    padding-block: 20px;
    padding-right: 20px;
    padding-left: 28px;
  }
}
